// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* D-pad — bottom-left in landscape */
#dpad {
  position: absolute;
  bottom: 16px;
  left: 72px;
  width: 160px;
  height: 160px;
  z-index: 15;
}

#dpad.hidden {
  display: none;
}

.dpad-btn {
  position: absolute;
  width: 48px;
  height: 48px;
  border: 1px solid rgba(100, 100, 160, 0.4);
  border-radius: 8px;
  background: rgba(15, 15, 30, 0.8);
  backdrop-filter: blur(6px);
  color: #aaaadd;
  font-size: 20px;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.1s;
}

.dpad-btn:active {
  background: rgba(70, 70, 140, 0.6);
}

/* Layout:
       [forward]
  [turnL] [turnR]
  [strL]   [strR]
       [backward]
*/
.dpad-forward     { left: 56px;  top: 0; }
.dpad-turn-left   { left: 0;     top: 48px; }
.dpad-turn-right  { left: 112px; top: 48px; }
.dpad-strafe-left { left: 0;     top: 104px; }
.dpad-strafe-right{ left: 112px; top: 104px; }
.dpad-backward    { left: 56px;  top: 104px; }

/* Back to edit button */
#back-to-edit-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 8px 16px;
  border: 1px solid rgba(100, 100, 160, 0.4);
  border-radius: 8px;
  background: rgba(15, 15, 30, 0.85);
  backdrop-filter: blur(8px);
  color: #aaaadd;
  font-size: 14px;
  font-family: system-ui, sans-serif;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  z-index: 15;
  transition: background 0.15s;
}

#back-to-edit-btn.hidden {
  display: none;
}

#back-to-edit-btn:hover {
  background: rgba(50, 50, 90, 0.8);
}
`, "",{"version":3,"sources":["webpack://./src/game/preview.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,iCAAiC;EACjC,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;;;CAKC;AACD,oBAAoB,UAAU,GAAG,MAAM,EAAE;AACzC,oBAAoB,OAAO,MAAM,SAAS,EAAE;AAC5C,oBAAoB,WAAW,EAAE,SAAS,EAAE;AAC5C,oBAAoB,OAAO,MAAM,UAAU,EAAE;AAC7C,oBAAoB,WAAW,EAAE,UAAU,EAAE;AAC7C,oBAAoB,UAAU,GAAG,UAAU,EAAE;;AAE7C,wBAAwB;AACxB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,0BAA0B;EAC1B,wCAAwC;EACxC,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["/* D-pad — bottom-left in landscape */\n#dpad {\n  position: absolute;\n  bottom: 16px;\n  left: 72px;\n  width: 160px;\n  height: 160px;\n  z-index: 15;\n}\n\n#dpad.hidden {\n  display: none;\n}\n\n.dpad-btn {\n  position: absolute;\n  width: 48px;\n  height: 48px;\n  border: 1px solid rgba(100, 100, 160, 0.4);\n  border-radius: 8px;\n  background: rgba(15, 15, 30, 0.8);\n  backdrop-filter: blur(6px);\n  color: #aaaadd;\n  font-size: 20px;\n  cursor: pointer;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.1s;\n}\n\n.dpad-btn:active {\n  background: rgba(70, 70, 140, 0.6);\n}\n\n/* Layout:\n       [forward]\n  [turnL] [turnR]\n  [strL]   [strR]\n       [backward]\n*/\n.dpad-forward     { left: 56px;  top: 0; }\n.dpad-turn-left   { left: 0;     top: 48px; }\n.dpad-turn-right  { left: 112px; top: 48px; }\n.dpad-strafe-left { left: 0;     top: 104px; }\n.dpad-strafe-right{ left: 112px; top: 104px; }\n.dpad-backward    { left: 56px;  top: 104px; }\n\n/* Back to edit button */\n#back-to-edit-btn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  padding: 8px 16px;\n  border: 1px solid rgba(100, 100, 160, 0.4);\n  border-radius: 8px;\n  background: rgba(15, 15, 30, 0.85);\n  backdrop-filter: blur(8px);\n  color: #aaaadd;\n  font-size: 14px;\n  font-family: system-ui, sans-serif;\n  cursor: pointer;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n  z-index: 15;\n  transition: background 0.15s;\n}\n\n#back-to-edit-btn.hidden {\n  display: none;\n}\n\n#back-to-edit-btn:hover {\n  background: rgba(50, 50, 90, 0.8);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
